export default __webpack_public_path__ + "static/media/system-agency-logo.ed955453.png";